import { useQuery } from '@tanstack/react-query'
import { api } from '@/services/api-client'

export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: () => api.getProjects(),
  })
}

export function useProject(id: string | null) {
  return useQuery({
    queryKey: ['project', id],
    queryFn: () => api.getProject(id!),
    enabled: !!id,
  })
}

export function useFolders(projectId: string | null) {
  return useQuery({
    queryKey: ['folders', projectId],
    queryFn: () => api.getFolders(projectId!),
    enabled: !!projectId,
  })
}

export function useThreads(projectId: string | null) {
  return useQuery({
    queryKey: ['threads', projectId],
    queryFn: () => api.getThreads(projectId!),
    enabled: !!projectId,
  })
}

export function useThread(id: string | null) {
  return useQuery({
    queryKey: ['thread', id],
    queryFn: () => api.getThread(id!),
    enabled: !!id,
    refetchOnWindowFocus: false,
  })
}

export function useDecisions(projectId: string | null) {
  return useQuery({
    queryKey: ['decisions', projectId],
    queryFn: () => api.getDecisions(projectId!),
    enabled: !!projectId,
  })
}

export function useProviders() {
  return useQuery({
    queryKey: ['providers'],
    queryFn: () => api.getProviders(),
    staleTime: 1000 * 60 * 10,
  })
}

export function useAvailableModels() {
  return useQuery({
    queryKey: ['available-models'],
    queryFn: () => api.getAvailableModels(),
    staleTime: 1000 * 60 * 5,
  })
}

export function useActivity(limit?: number) {
  return useQuery({
    queryKey: ['activity', limit],
    queryFn: () => api.getActivity(limit),
  })
}

export function useAppProjects() {
  return useQuery({
    queryKey: ['app-projects'],
    queryFn: () => api.getAppProjects(),
  })
}

export function useAppProject(id: string | null) {
  return useQuery({
    queryKey: ['app-project', id],
    queryFn: () => api.getAppProject(id!),
    enabled: !!id,
  })
}
